









import Topbar from "@/components/TheTopbar.vue";
import Sidebar from "@/components/TheSidebar.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { Route } from "vue-router";
import { currentScoutingStore } from "@/store/typed";
Component.registerHooks(["beforeRouteEnter"]);

@Component({ components: { Topbar, Sidebar } })
export default class Container extends Vue {
  async beforeRouteEnter(
    to: Route,
    _from: Route,
    next: (...params: any[]) => void
  ) {
    try {
      const scouting = await currentScoutingStore.loadCurrentScouting();
      next();
    } catch (e) {
      console.error(e);
    }
  }
}
